import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../services/api/axios.config";
import { notify } from "../utils/methods/notification";
import { capitalizeFirstLetter } from "../../utils/utils"

const initialState = {
  manufactureProductList: {},
  startProductList: {},
  isLoading: false,
  volumBagList: [],
  volumBagListDrop: [],
  highest_cycle: null,
  manufacture_has_na_cycle:null,
};

// For Fetching Approved LSM Listing
export const getApprovedLSMLogisticsListing = createAsyncThunk(
  "bmr/getApprovedLSMLogisticsListing",
  async (filters, { rejectWithValue }) => {
    try {
      const response = await api.post(`/logistics/approved/list`, filters);
      return response.data;
    } catch (error) {
      notify.error(
        error || error.message || error.response || error.response.data
      )
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const updateCartForm = createAsyncThunk(
  "bmr/updateCartTForm",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/cart-t-form/update/${id}`, formData);
      return response.data;
    } catch (error) {
      notify.error(error?.response?.data || error?.message || error)
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Start Product Manufacturing
export const productStartManufacturing = createAsyncThunk(
  "bmr/productStartManufacturing",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(`/product-manufacturing/start`, data);
      notify.success(response.data.message);
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.response?.data || error?.message || error || "Failed to start manufacturing";
      notify.error(errorMessage);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// fetch bags list
export const volumnBagList = createAsyncThunk(
  "bmr/product-manufacturing/bags/list",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`/product-manufacturing/bags/list/${id}`);
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.response?.data || error?.message || error || "Failed to start manufacturing";
      notify.error(errorMessage);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//add infusion date
export const addInfusionDate = createAsyncThunk(
  "bmr/addinfusionDate",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.put(`/outbound-form/assign/infusion`, data);
      notify.success(response.data.message);
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.response?.data || error?.message || error || "Failed to start manufacturing";
      notify.error(errorMessage);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Fail Product Manufacturing
export const productFailManufacturing = createAsyncThunk(
  "bmr/productFailManufacturing",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.put(`/product-manufacturing/fail`, data);
      notify.success(response.data.message || "Manufacturing marked as failed");
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error.response.data || error.response || error?.message || error || "Failed to mark manufacturing as failed";
      notify.error(errorMessage);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Complete Product Manufacturing
export const productCompleteManufacturing = createAsyncThunk(
  "bmr/productCompleteManufacturing",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.put(`/product-manufacturing/complete`, data);
      notify.success(response.data.message || "Manufacturing completed successfully");
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error.response.data || error.response || error?.message || error || "Failed to complete manufacturing";
      notify.error(errorMessage);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Complete Product Manufacturing
export const restartProductManufacturing = createAsyncThunk(
  "bmr/restartProductManufacturing",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.put(`/product-manufacturing/restart`, data);
      notify.success(response.data.message || "Manufacturing restarted successfully");
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error.response.data || error.response || error?.message || "Failed to restart manufacturing";
      notify.error(errorMessage);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// @info Marked as markedAsAccpetManufacturing for portal 1
export const markedAsAccpetManufacturing = createAsyncThunk(
  'bmr/markedAsAccpetManufacturing',
  async (args, { rejectWithValue }) => {
    try {
      const { data, feasibility_assessment_id, inbound_patient_id } = args
      const response = await api.patch(`/product-manufacturing/accept/${feasibility_assessment_id}`, { ...data, inbound_patient_id: inbound_patient_id });
      notify.success(response?.data?.message);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

// @info Marked as markedAsAccpetManufacturing for portal 1
export const markedAsRejectLSM = createAsyncThunk(
  'bmr/markedAsRejectLSM',
  async (args, { rejectWithValue }) => {
    try {
      const { data, inbound_patient_id } = args
      const response = await api.put(`/logistics/reject/inbound/${inbound_patient_id}`, data);
      notify.success(response?.data?.message);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);


// @info Marked as markedAsAccpetManufacturing for portal 1
export const markedAsCryopreserveLSM = createAsyncThunk(
  'bmr/markedAsCryopreserveLSM',
  async (args, { rejectWithValue }) => {
    try {
      const { subject_id, inbound_patient_id, data } = args
      const response = await api.patch(`/inbond-patient/lsm/cryopreserve/${inbound_patient_id}/${subject_id}`, data);
      notify.success(response?.data?.message);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

export const addCryoPData = createAsyncThunk(
  'bmr/product-manufacturing/bags/add',
  async (args, { rejectWithValue }) => {
    try {
      const { data } = args
      const response = await api.post(`/product-manufacturing/bags/add`, data);
      notify.success(response?.data?.message);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

export const updateMonocyte = createAsyncThunk(
  'bmr/product-manufacturing/monocyte-update',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.patch(
        `/product-manufacturing/monocyte-update`,
        data
      );
      notify.success(response?.data?.message || "Monocyte updated successfully");
      return response.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data ||
        error?.message || error ||
        "Failed to update monocyte";

      notify.error(errorMessage);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const printCryoPData = createAsyncThunk(
  'bmr/product-manufacturing/printCryoPData',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.patch(`/product-manufacturing/bags/print-count`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);
// @info Marked as markedAsAccpetManufacturing for portal 1
export const terminateCycle = createAsyncThunk(
  'bmr/terminateCycle',
  async (args, { rejectWithValue }) => {
    try {
      const { data } = args
      const response = await api.put(`/product-manufacturing/terminate/cycle`, data);
      notify.success(response?.data?.message);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

// @info Marked as markedAsAccpetManufacturing for portal 1
export const poolCycleSubmit = createAsyncThunk(
  'bmr/poolCycle',
  async (args, { rejectWithValue }) => {
    try {
      const { data } = args
      const response = await api.put(`/product-manufacturing/pool/cycle`, data);
      notify.success(response?.data?.message);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

export const approveChangeRequest = createAsyncThunk(
  'bmr/approveChangeRequest',
  async (args, { rejectWithValue }) => {
    try {
      const { data } = args
      const response = await api.put(`/product-manufacturing/approve/request`, data);
      notify.success(response?.data?.message);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

export const rejectChangeRequest = createAsyncThunk(
  'bmr/rejectChangeRequest',
  async (args, { rejectWithValue }) => {
    try {
      const { data } = args
      const response = await api.put(`/product-manufacturing/reject/request`, data);
      notify.success(response?.data?.message);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);
// 👇 NEW: Edit a specific bag by its ID
// PUT /product-manufacturing/bags/update/:id
// Body: { cd3_count, storage_location_id, feasibility_assessment_id }
export const editCryoPData = createAsyncThunk(
  'bmr/product-manufacturing/bags/update',
  async (args, { rejectWithValue }) => {
    try {
      const { id, data } = args
      const response = await api.put(`/product-manufacturing/bags/update/${id}`, data);
      notify.success(response?.data?.message || 'Bag updated successfully');
      return response.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data ||
        error?.message || error ||
        'Failed to update bag';
      notify.error(errorMessage);
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);


const bmrManufactureSlice = createSlice({
  name: "bmrManufacturing",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      // Handling the state case for the LSM Approved listing
      .addCase(getApprovedLSMLogisticsListing.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getApprovedLSMLogisticsListing.fulfilled, (state, action) => {
        // Structure the data to match what the component expects
        state.manufactureProductList = {
          items: action.payload?.data ?? [],
          pageDetails: action.payload?.pageDetails ?? {
            total_count: 0,
            page: 1,
            per_page: 10
          }
        };
        state.manufacture_has_na_cycle = action.payload?.data?.has_na_cycle ?? null;
        const highestCycle = action.payload.data?.highest_cycle ?? action.payload.highest_cycle ?? null;
        state.highest_cycle =  highestCycle; 
        state.isLoading = false;
      })
      .addCase(getApprovedLSMLogisticsListing.rejected, (state) => {
        state.isLoading = false;
      })

      // Start Manufacturing cases
      .addCase(productStartManufacturing.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(productStartManufacturing.fulfilled, (state, action) => {
        state.startProductList = action.payload;
        state.isLoading = false;
      })
      .addCase(productStartManufacturing.rejected, (state) => {
        state.isLoading = false;
      })
      //volumn bags
      .addCase(volumnBagList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(volumnBagList.fulfilled, (state, action) => {
        state.volumBagList = action.payload?.data;
        state.volumBagListDrop = action.payload?.data?.filter((it) => it?.status !== 1)?.map((it) => ({
          value: it?.id,
          label: `Bag${capitalizeFirstLetter(it?.identifier)} : Volume = ${it?.volume}, CD3+ = ${it?.cd3_count} x 10⁶ Cells, ${it?.storage_location?.name}`
        }));
        state.isLoading = false;
      })
      .addCase(volumnBagList.rejected, (state) => {
        state.isLoading = false;
      })

      // Fail Manufacturing cases
      .addCase(productFailManufacturing.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(productFailManufacturing.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(productFailManufacturing.rejected, (state) => {
        state.isLoading = false;
      })

      // Complete Manufacturing cases
      .addCase(productCompleteManufacturing.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(productCompleteManufacturing.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(productCompleteManufacturing.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(restartProductManufacturing.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(restartProductManufacturing.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(restartProductManufacturing.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(markedAsAccpetManufacturing.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(markedAsAccpetManufacturing.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(markedAsAccpetManufacturing.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(markedAsRejectLSM.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(markedAsRejectLSM.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(markedAsRejectLSM.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(markedAsCryopreserveLSM.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(markedAsCryopreserveLSM.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(markedAsCryopreserveLSM.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(updateMonocyte.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateMonocyte.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateMonocyte.rejected, (state) => {
        state.isLoading = false;
      })
      // 👇 NEW: editCryoPData reducer cases
      .addCase(editCryoPData.pending, (state) => { state.isLoading = true; })
      .addCase(editCryoPData.fulfilled, (state) => { state.isLoading = false; })
      .addCase(editCryoPData.rejected, (state) => { state.isLoading = false; })
});

export const selectManufactureProductLoading = (state) => state.bmrManufacturing.isLoading
export const selectManufactureProductList = (state) => state.bmrManufacturing.manufactureProductList;
export const productManufacturing = (state) => state.bmrManufacturing.manufactureProductList;
export const selectDynamicBags = (state) => state.bmrManufacturing.volumBagList;
export const selectDynamicBagDropDown = (state) => state.bmrManufacturing.volumBagListDrop;
export const selectHighestCycle = (state) => state.bmrManufacturing.highest_cycle;
export const selectManufacturehasNacycle = (state) => state.bmrManufacturing.manufacture_has_na_cycle;

export default bmrManufactureSlice.reducer;